interface TaskQueue {
    addTask(taskId:string, task:Function): boolean;
    executeTask(taskId:string): boolean
}

class taskQueue implements TaskQueue{
    constructor() {}
    protected taskCache: Map<string,Function> = new Map<string,Function>();

    addTask(taskId: string, task: Function): boolean {
        if(this.taskCache.has(taskId)){
            return false
        }
        else{
            this.taskCache.set(taskId, task);
            return true
        }
    };

    executeTask(taskId:string):boolean{
        if(this.taskCache.has(taskId)){
            let getTask = this.taskCache.get(taskId);
            if(getTask){
                getTask();
                this.taskCache.delete(taskId);
                return true;
            }
        }
        return false;
    }
}

const task = new taskQueue();
export default task

